export default __webpack_public_path__ + "static/media/Henry.3bd0fd38.png";